// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2ybxY","header":"Messages_header__2ZkW3"};